import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useTranslation } from "@/hooks/useTranslation";
import { AdminUserHistoryDTO } from "@shaarp/common";

export default function DataTableCellAdminUsersHistoryTeamAvatar({
  userHistory,
}: {
  userHistory: AdminUserHistoryDTO;
}) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center">
      <Avatar className="w-5 h-5 mr-2">
        <AvatarImage
          src={`https://avatar.vercel.sh/${userHistory.team?.id || "unknown"}.png`}
          alt={userHistory.team?.name || ""}
          className="grayscale"
        />
        <AvatarFallback>
          {userHistory.team?.name?.slice(0, 2).toUpperCase() || "-"}
        </AvatarFallback>
      </Avatar>
      <span className="ml-2">
        {userHistory.team?.name || t("admin.usersHistory.unknown.team")}
      </span>
    </div>
  );
}
